import { SITE } from "@/lib/site";
import meetSomoHero from "@/assets/meet-somo-hero.webp?w=640;960;1280;1920;2560;3780&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";
import { CtaRow } from "@/components/CtaRow";
import { Divider, SectionDivider } from "@/components/Divider";
import { EcosystemSection } from "@/components/EcosystemSection";
import { HardwareSoftwareSection } from "@/components/HardwareSoftwareSection";
import { PageShell } from "@/components/PageShell";
import { IntegrationsSection } from "@/components/IntegrationsSection";
import { PageHero } from "@/components/PageHero";
import { PropertyFitSection } from "@/components/PropertyFitSection";
import { TestimonialSection } from "@/components/TestimonialSection";
import { ValuePropsSection } from "@/components/ValuePropsSection";

export function MeetSomoPage() {
  return (
    <PageShell className="bg-primary">
      <PageHero
        image={responsiveImage(meetSomoHero)}
        imagePosition="33% center"
        imageAlt="Somo keypad on a fabric headboard beside a bed, under a glass pendant light"
        title="Everything behind the room, working as one"
        body="Meet the ecosystem behind Somo: hardware for the room, software for configuration and management, and a platform that connects it all."
        align="start"
        cta={{ label: "Explore the Ecosystem", href: "#ecosystem" }}
      />
      <EcosystemSection />
      <div className="md:hidden">
        <Divider />
      </div>
      <PropertyFitSection />
      <HardwareSoftwareSection />
      <SectionDivider />
      <IntegrationsSection />
      <SectionDivider />
      <ValuePropsSection />
      <SectionDivider />
      <TestimonialSection />
      <div className="bg-secondary md:bg-transparent">
        <CtaRow
          title="Bring Somo to your property"
          body="See how Somo can create a better experience for your guests, your operations, and your bottom line."
          cta={{ label: "Let’s Talk", href: `${SITE}/contact` }}
        />
      </div>
    </PageShell>
  );
}
